<template>
    <div class="publicMain">
        <div class="mianbao">
            <!--  -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>养老服务机构</el-breadcrumb-item>
                <el-breadcrumb-item>居家养老</el-breadcrumb-item>
                <el-breadcrumb-item>兴康服务对象</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 表格 -->
        <div class="table">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    header-align="center"
                    align="center"
                ></el-table-column>
                <el-table-column
                    v-for="(item, index) in tableColumn"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    align="left"
                    header-align="center"
                >
                    <template slot-scope="scope">
                        <div v-if="item.type == 'button'" style="width: 400px">
                            <el-tooltip
                                class="item"
                                effect="light"
                                content="查看"
                                placement="top-start"
                            >
                                <button
                                    class="iconfont icon-chakan tabBtn"
                                    @click="check(scope.row)"
                                ></button>
                            </el-tooltip>

                            <!-- <el-button type="primary" size='mini' @click="check(scope.row)">查看</el-button>
                            <el-button type="primary" size='mini' @click="compile(scope.row)">修改</el-button>
                            <el-button type="danger"  size='mini' @click="remove(scope.row)">删除</el-button>-->
                            <!--                            <el-button type="primary" size="mini" @click="pass(scope.row)">启用</el-button>-->
                            <!--                            <el-button type="danger" size="mini" @click="unpass(scope.row)">禁用</el-button>-->
                        </div>
                        <div
                            v-if="item.type == 'state'"
                            style="display: flex; justify-content: center"
                        >
                            <el-tag
                                v-if="scope.row[item.prop] == 0"
                                type="danger"
                                >禁用</el-tag
                            >
                            <el-tag
                                v-if="scope.row[item.prop] == 1"
                                type="success"
                                >启用</el-tag
                            >
                        </div>
                        <div
                            v-else
                            :style="{
                                'text-align': item.align
                                    ? item.align
                                    : 'center',
                            }"
                        >
                            {{ scope.row[item.prop] }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <!-- 弹窗 -->
        <el-dialog :title="title" :visible.sync="visible" width="50%">
            <div class="slot">
                <provideHeKangPeople
                    :buttonType="buttonType"
                    :row="row"
                    @save="save"
                    @cancel="cancel"
                    v-if="visible"
                />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getHeKangObject } from "./api"
import provideHeKangPeople from "./components/provideHeKangPeople.vue"
import axios from "axios"
const request = axios.create()
export default {
    components: {
        provideHeKangPeople,
    },
    data() {
        return {
            currentPage: 1, //默认展示第一页
            buttonType: "", //按钮的类型
            row: {}, //点击当前按钮的row数据
            title: "",
            visible: false,
            formModel: {}, //模糊查询
            //table表格的column
            tableColumn: [
                {
                    prop: "name",
                    label: "员工姓名",
                },
                {
                    prop: "workNo",
                    label: "员工号",
                },
                {
                    prop: "mobilePhone",
                    label: "手机号码",
                },
                {
                    prop: "familyPhone",
                    label: "家庭电话",
                },
                {
                    prop: "nation",
                    label: "民族",
                },
                {
                    prop: "position",
                    label: "员工职位",
                },
                {
                    prop: "address",
                    label: "详细地址",
                },
                {
                    type: "button",
                    label: "操作",
                },
            ],
            //table表格的数据
            tableData: [],
            total: 0, //总数据
            pageNo: 1,
            pageSize: 10,
            request,
        }
    },
    methods: {
        //模糊搜索的查询
        onCheck() {
            this.getHelpManageAPI({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.formModel,
            })
        },
        //模糊搜索的重置
        onReset() {
            this.formModel = {}
            this.getHelpManageAPI({
                pageNo: 1,
                pageSize: 10,
            })
        },
        //每页请求N条数据
        handleSizeChange(val) {
            this.pageSize = val
            this.getHelpManageAPI()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求N页数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.getHelpManageAPI()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        //查看
        check(row) {
            this.visible = true
            this.row = row
            this.buttonType = "check"
        },

        // //拿到数据
        // fun(){
        //     // let params = new FormData()
        //     // params.append("pageNo", 3);
        //     // params.append("pageSize", 10);
        //         this.request({
        //             url: "http://36.33.216.70:9977/njhk-wisdom-datasys-web-api/customer/info/customerLists?pageNo=2&pageSize=10",
        //             method: "POST",
        //             data: {}
        //         }).then(res=>{
        //             console.log('res',res.data.content.list)
        //             this.tableData = res.data.content.list
        //         })
        //
        // },
        //拿到列表
        getHeKangObjectAPI(e) {
            let params = Object.assign({}, e, {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            })
            getHeKangObject(params).then((res) => {
                this.tableData = res.content.content.list
                this.total = res.content.content.count
            })
        },
    },
    created() {
        // this.getHeKangObjectAPI()
    },
}
</script>

<style lang="less" scoped>
.publicMain {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}
// 面包屑导航box
.mianbao {
    box-sizing: border-box;
    margin: -16px -16px 0;
    background-color: #eef1f6;
    height: 47px;
    align-items: center;
    padding-left: 16px;
    margin-bottom: 16px;
}
.childrenFileSelect {
    border: 1px solid rgb(230, 230, 230);
    padding: 20px;
    margin-top: 20px;
}
.table {
    margin: 20px 0px;
}
.add {
    margin: 20px 0px;
}
.slot {
    width: 90%;
    margin: auto;
}
.icon-icon7 {
    color: #dd3020;
}
.icon-tongguos {
    color: #0d5795;
}
</style>
